import React from "react";
import PropTypes from "prop-types";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";

const mediaQueryWidths = {
  web: {
    min: "200px",
  },
  tablet: {
    min: "768px",
    max: "1025px",
  },
  phone: {
    max: "767px",
  },
};
interface StaticImage {
  loading: string;
  srcList: any;
  alt: string;
  className: string;
  onClick?: () => void;
}

const StaticImage = ({
  loading = "lazy",
  srcList = [],
  alt = "image",
  className,
  onClick = () => {
    console.log();
  },
}: StaticImage) => {
  const fallbackObj = srcList.find((item: any) => item.type === "web");
  const { screen }: any = useWindowSize();
  console.log(loading, alt, className, onClick, fallbackObj, fallbackObj?.src);
  return (
    <picture>
      {srcList.map((item: any, index: any) => {
        const widthRange: any = mediaQueryWidths["web"];
        const minMediaWidth = widthRange?.min
          ? `(min-width: ${widthRange.min})`
          : "";
        const maxMediaWidth = widthRange?.max
          ? `(max-width: ${widthRange.max})`
          : "";
        const sourceMediaQuery = `${minMediaWidth}${
          [minMediaWidth, maxMediaWidth].includes("") ? "" : " and "
        }${maxMediaWidth}`;
        console.log("sourceMediaQuery", sourceMediaQuery);
        return (
          <source
            key={index}
            srcSet={item.src}
            width={item.width}
            height={item.height}
            media={sourceMediaQuery}
          />
        );
      })}
      <img
        src={fallbackObj?.src || ""}
        alt={alt}
        className={className}
        width={["xxl", "xl", "lg"].includes(screen) ? "500px" : "250px"}
        height={fallbackObj.height}
        onClick={onClick}
      />
    </picture>
  );
};

StaticImage.propTypes = {
  srcList: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
};

export default StaticImage;
